// extracted by mini-css-extract-plugin
export default {"videoModal":"VideoPlayerModal_videoModal__ivZ5u"};